module.exports = __webpack_public_path__ + "static/img/score-mobile-3.625a7307.png";